/**
 * User requests removal functionality
 *
 * This Source Code Form is subject to the terms of the Mozilla Public License,
 * v. 2.0. If a copy of the MPL was not distributed with this file, You can
 * obtain one at https://mozilla.org/MPL/2.0/.
 *
 * @package   phpMyFAQ
 * @author    Thorsten Rinne <thorsten@phpmyfaq.de>
 * @copyright 2024-2026 phpMyFAQ Team
 * @license   https://www.mozilla.org/MPL/2.0/ Mozilla Public License Version 2.0
 * @link      https://www.phpmyfaq.de
 * @since     2024-03-09
 */

import { requestUserRemoval } from '../api';
import { addElement } from '../utils';

export const handleRequestRemoval = () => {
  const requestRemovalSubmit = document.getElementById('pmf-submit-request-removal') as HTMLButtonElement | null;

  if (requestRemovalSubmit) {
    requestRemovalSubmit.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const formValidation = document.querySelector('.needs-validation') as HTMLFormElement;
      if (!formValidation.checkValidity()) {
        formValidation.classList.add('was-validated');
      } else {
        const form = document.querySelector('#pmf-request-removal-form') as HTMLFormElement;
        const loader = document.getElementById('loader') as HTMLElement;
        const formData = new FormData(form);
        const message = document.getElementById('pmf-request-removal-response') as HTMLElement;

        try {
          const response = await requestUserRemoval(formData);

          if (response.success) {
            loader.classList.add('d-none');
            message.insertAdjacentElement(
              'afterend',
              addElement('div', { classList: 'alert alert-success', innerText: response.success })
            );
            form.reset();
          }

          if (response.error) {
            loader.classList.add('d-none');
            message.insertAdjacentElement(
              'afterend',
              addElement('div', { classList: 'alert alert-danger', innerText: response.error })
            );
          }
        } catch (error) {
          loader.classList.add('d-none');
          message.insertAdjacentElement(
            'afterend',
            addElement('div', { classList: 'alert alert-danger', innerText: (error as Error).message })
          );
        }
      }
    });
  }
};
